import { computed, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStorage } from '../../enums/app-storage';
import { RoleTypes } from '../../constants/role-types.constant';
import { TenantService } from '../../services/tenant/tenant.service';
import { CookieService } from '../../services/cookie/cookie.service';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { FEATURE_FLAGS } from '../../constants/feature-flags.constants';

export const employeeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tenantService = inject(TenantService);
  const cookieService = inject(CookieService);
  const featureFlagsService = inject(FeatureFlagsService);
  const isSwitchingPortalEnabled = computed(() =>
    featureFlagsService.getFeatureFlagValue(
      FEATURE_FLAGS.SYSTEM.portal_settings
    )
  );
  const isTokenPresent = !!cookieService.get(AppStorage.token);
  const role = cookieService.get(AppStorage.role);
  const parsedRole = role ? JSON.parse(role) : null;
  let isRoleVendor = false;
  const allowVendorAccess = Array.isArray(parsedRole)
    ? parsedRole.includes(RoleTypes.VENDOR) &&
      parsedRole.includes(RoleTypes.EMPLOYEE)
    : false;

  if (parsedRole) {
    if (Array.isArray(parsedRole)) {
      isRoleVendor =
        parsedRole.includes(RoleTypes.VENDOR) &&
        !parsedRole.includes(RoleTypes.EMPLOYEE);
    } else {
      isRoleVendor = parsedRole.name === RoleTypes.VENDOR;
    }
  }

  if (isTokenPresent && allowVendorAccess && isSwitchingPortalEnabled()) {
    return true;
  }

  if (isTokenPresent && isRoleVendor) {
    // If it's a vendor trying to access employee flow, redirect to vendor portal
    router.navigate([tenantService.vendorPath()]);
    return false;
  }

  return true;
};
